import { MapObject } from "./map-object";
import { PJ } from "app/shared/data/pj";
import { PJDuplicate } from 'app/shared/data/pjDuplicate';

export class PJDuplicates {

    constructor(public count: number, public start: number, public limit: number, public duplicates: Array<PJDuplicate>) {}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/pjDuplicates.ts